import { callAPI } from "../config/api";

const PATH_API = process.env.REACT_APP_API;

export async function getMaritalStatus(data: any) {
    const url = `${PATH_API}/marital-status/filtered`;
    return await callAPI({
        url,
        method: "POST",
        data: data
    });
}

